import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
import { State } from './model';


const Reducer = handleActions({
  'search/POST_REQUEST': (state, { payload }) => {
    return state.setIn(['isPosting'], true)
                .setIn(['errMsg'], null);
  },
  'search/POST_SUCCESS': (state, { payload }) => {
    return state.setIn(['isPosting'], false)
                .setIn(['errMsg'], null);
  },
  'search/POST_FAILURE': (state, { payload }) => {
    return state.setIn(['isPosting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'search/GET_REQUEST': (state, { payload }) => {
    return state.setIn(['isGetting'], true)
                .setIn(['errMsg'], null);
  },
  'search/GET_SUCCESS': (state, { payload }) => {
    return state.setIn(['isGetting'], false)
                .setIn(['errMsg'], null);
  },
  'search/GET_FAILURE': (state, { payload }) => {
    return state.setIn(['isGetting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'search/SEARCH_REQUEST': (state, { payload }) => {
    return state.setIn(['isSearching'], true)
                .setIn(['searchErrMsg'], null)
                .setIn(['totalHits'], 0)
                .setIn(['hitList'], fromJS([]));
  },
  'search/SEARCH_SUCCESS': (state, { payload }) => {
    return state.setIn(['isSearching'], false)
                .setIn(['searchErrMsg'], null);
  },
  'search/SEARCH_FAILURE': (state, { payload }) => {
    return state.setIn(['isSearching'], false)
                .setIn(['searchErrMsg'], payload.errMsg);
  },
  'search/UPDATE_SEARCH_RESULT': (state, { payload }) => {
    return state.setIn(['totalHits'], payload.totalHits)
                .setIn(['hitList'], fromJS(payload.hitList))
                .setIn(['cacheId'], payload.cacheId);
  },
  'search/UPDATE_CASE_LIST': (state, { payload }) => {
    return state.setIn(['caseList'], fromJS(payload));
  },
}, State);

export default Reducer;